import AnalysisSoudanCurrentBefore from 'views/Analysis/AnalysisSoudanCurrentBefore';
import AnalysisSoudanBigSmall from 'views/Analysis/AnalysisSoudanBigSmall';

import { ComparisonKind } from 'views/Analysis/analysisUtils';

// 分析（相談件数）
function AnalysisSoudan(props) {
  // 分析情報
  const quoteList = props.quoteList;
  // 選択中の期
  const selectedPeriod = props.selectedPeriod;

  // 昨対比 or 工事／管・小
  return props.comparisonKind === ComparisonKind.CURRENT_BEFORE ? (
    <AnalysisSoudanCurrentBefore
      quoteList={quoteList}
      selectedPeriod={selectedPeriod}
    ></AnalysisSoudanCurrentBefore>
  ) : (
    <AnalysisSoudanBigSmall
      quoteList={quoteList}
      selectedPeriod={selectedPeriod}
    ></AnalysisSoudanBigSmall>
  );
}
export default AnalysisSoudan;
